/**
 * Featured tags configuration for Anush Cuidarte.
 */
export const featuredTags = ['Todos', 'Lactancia', 'Lesiones', 'Embarazo', 'Enfermeria', 'Recien nacido', 'Vacunacion'];
